import ProductIssueState from "@/models/Products/ProductIssues/ProductIssueState";

export default (val: ProductIssueState) => {
    let returnVal = "Undefined";
    switch (val) {
        case ProductIssueState.Pending:
            returnVal = "Pending"
            break;
        case ProductIssueState.Published:
            returnVal = "Published"
            break;
        case ProductIssueState.Rejected:
            returnVal = "Rejected"
            break;
    }
    return returnVal;
}